export default "__VITE_ASSET__CrqXi0bA__"